import Breakdown from './components/Breakdown';
import Overview from './components/Overview';
import Reward from './components/Reward';

import { CollapsibleElement } from '../shared/collapsibleElement/CollapsibleElement';
import { LoaderElement } from '../shared/loaderElement/LoaderElement';
import { SectionElement } from '../shared/sectionElement/SectionElement';
import type { ReferralsElementProps } from './ReferralsElement.types';

export function ReferralsElement(props: ReferralsElementProps) {
  const { translations, children, element, isLoading, onClickCopy } = props;
  const { data } = element.attrs || {};

  if (isLoading) {
    return (
      <SectionElement
        title={translations?.['referrals.summary.title']}
        subTitle={translations?.['referrals.summary.description']}
      >
        <LoaderElement count={4} />
      </SectionElement>
    );
  }

  return (
    <SectionElement
      title={translations?.['referrals.summary.title']}
      subTitle={translations?.['referrals.summary.description']}
    >
      <Overview
        referralLink={data?.referral_link ?? ''}
        referralCount={data?.referral_count ?? 0}
        onClickCopy={onClickCopy}
        translations={translations}
      />
      <div className="w-full flex items-center justify-center mt-4">
        <CollapsibleElement className="w-full" showButtonLabel={translations?.['referrals.summary.show_more_button']}>
          <div className="flex flex-col gap-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {data?.rewards?.map((reward) => (
                <Reward
                  key={reward.id}
                  name={reward.name}
                  description={reward.description}
                  disclaimer={reward.disclaimer}
                  image={reward?.image?.thumb?.url || reward?.placeholder_image}
                  isAchieved={reward.is_achieved}
                  numerator={reward.num_referrals - reward.num_referrals_until}
                  denominator={reward.num_referrals}
                  translations={translations ?? {}}
                />
              ))}
            </div>
            <Breakdown
              pending={data?.referrals?.pending || []}
              confirmed={data?.referrals?.confirmed || []}
              translations={translations}
            />
          </div>
        </CollapsibleElement>
      </div>
      {children}
    </SectionElement>
  );
}
